function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  min-width: 100%;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n\n  .main-menu-expand {\n    background-color: ",
        ";\n\n    vwc-icon,\n    vwc-icon-button {\n      --connotation: ",
        ";\n    }\n  }\n\n  .collapsed-title {\n    background-color: ",
        "30;\n    line-height: 18px;\n    padding-left: ",
        "px;\n    padding-right: ",
        "px;\n    color: ",
        ';\n    position: relative;\n\n    &:before {\n      content: "";\n      position: absolute;\n      height: 0px;\n      width: 0px;\n      top: 0px;\n      left: 0;\n      border-width: 9px;\n      border-color: ',
        ';\n      border-style: solid;\n    }\n\n    &:after {\n      content: "";\n      position: absolute;\n      height: 0px;\n      width: 0px;\n      top: 0px;\n      right: -18px;\n      border-width: 9px;\n      border-color: ',
        ";\n      border-style: solid;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import css from "@styled-system/css";
import styled from "styled-components";
export { Column, dark, light, Row, Spacer, theme } from "../../styles";
export var MAIN_NAVIGATION_HEIGHT = "3.5rem";
export var Nav = styled.nav(css({
    "& li": {
        "& a, span": {
            "&:hover, &.active": {
                borderBottomColor: function(theme) {
                    return theme.accentColorActive;
                },
                color: function(theme) {
                    return theme.accentColorActive;
                }
            },
            alignItems: "center",
            borderBottom: "2px solid transparent",
            display: "flex",
            justifyContent: "center",
            paddingX: "sm"
        },
        "& span.active": {
            cursor: "default"
        },
        alignItems: "center",
        display: "flex",
        marginX: "sm",
        textAlign: "center"
    },
    "& li > a": {
        color: function(theme) {
            return theme.accentColor;
        },
        textDecoration: "none"
    },
    "& ol": {
        display: "flex",
        justifyContent: "flex-start",
        listStyleType: "none",
        margin: 0,
        paddingLeft: 0,
        width: "100%"
    },
    alignItems: "center",
    backgroundColor: function(theme) {
        return theme.primaryColor;
    },
    boxShadow: "0 0 6px -2px gray",
    boxSizing: "border-box",
    color: function(theme) {
        return theme.accentColor;
    },
    display: "flex",
    flexDirection: "row",
    fontSize: "14px",
    height: MAIN_NAVIGATION_HEIGHT,
    justifyContent: "space-between",
    paddingX: "xl",
    paddingY: "sm",
    position: "fixed",
    top: "var(--bifrost-header-height, 0px)",
    width: "100%",
    zIndex: "1"
}));
export var Wrapper = styled.div(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.primaryColor;
}, function(param) {
    var theme = param.theme;
    return theme.accentColor;
}, function(param) {
    var theme = param.theme;
    return theme.accentColor;
}, function(param) {
    var theme = param.theme;
    return theme.space.md;
}, function(param) {
    var theme = param.theme;
    return theme.space.xs;
}, function(param) {
    var theme = param.theme;
    return theme.accentColor;
}, function(param) {
    var theme = param.theme;
    return "transparent transparent transparent ".concat(theme.primaryColor);
}, function(param) {
    var theme = param.theme;
    return "transparent transparent transparent ".concat(theme.accentColor, "30");
});

//# sourceMappingURL=styles.js.map